export default __webpack_public_path__ + "static/media/004-B-logementProprietaire.3d5d6cfc.svg";